// User APIs

import "whatwg-fetch";
import { optionsGen } from "../helpers/api";
import { API_URL } from "../config";

const USER_URL = `${API_URL}/users`;

export function retrieveUser(email) {
  let url = USER_URL;
  return fetch(url, optionsGen("POST", { email }, true)).then(resp => resp.json());
}

export function createQuery(payload) {
  // query, user_id in payload
  let url = `${USER_URL}/queries`;
  return fetch(url, optionsGen("POST", payload, true)).then(resp => resp.json());
}

export function getQueryById(query_id) {
  let url = `${USER_URL}/queries/${query_id}`;
  return fetch(url, optionsGen("GET", null, true)).then(resp => resp.json());
}

export function getProjects(user_id) {
  return fetch(`${USER_URL}/${user_id}/projects`, optionsGen("GET", null, true)).then(resp => resp.json());
}

export function createProject(user_id, payload) {
  return fetch(`${USER_URL}/${user_id}/projects`, optionsGen("POST", payload, true)).then(resp => resp.json());
}

export function getProjectById(user_id, project_id) {
  return fetch(`${USER_URL}/${user_id}/projects/${project_id}`, optionsGen("GET", null, true)).then(resp => resp.json());
}

export function updateProjectById(user_id, project_id, payload) {
  return fetch(`${USER_URL}/${user_id}/projects/${project_id}`, optionsGen("PUT", payload, true)).then(resp => resp.json());
}

export function deleteProjectById(user_id, project_id) {
  return fetch(`${USER_URL}/${user_id}/projects/${project_id}`, optionsGen("DELETE", null, true)).then(resp => resp.json());
}

export function getPortfoliosByProjectId(user_id, project_id) {
  return fetch(`${USER_URL}/${user_id}/projects/${project_id}/portfolios`, optionsGen("GET", null, true)).then(resp => resp.json());
}

export function createPortfolioByProjectId(user_id, project_id, payload) {
  return fetch(`${USER_URL}/${user_id}/projects/${project_id}/portfolios`, optionsGen("POST", payload, true)).then(resp => resp.json());
}

export function deletePortfolioByIdWithProjectId(user_id, project_id, portfolio_id) {
  return fetch(`${USER_URL}/${user_id}/projects/${project_id}/portfolios/${portfolio_id}`, optionsGen("DELETE", null, true)).then(resp => resp.json());
}

export function storeMessages(payload) {
  return fetch(`${USER_URL}/events`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function incrementDailyMessageCount(user_id) {
  return fetch(`${USER_URL}/message-count/increment/${user_id}`, optionsGen("POST", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getDailyMessageCount(user_id) {
  return fetch(`${USER_URL}/message-count/today/${user_id}`, optionsGen("GET", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}